import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'

Vue.use(Router)

//获取原型对象上的push函数
const originalPush = Router.prototype.push;
//修改原型对象中的push方法
Router.prototype.push = function (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err);
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/projects/:id',
      name: 'projects',
      component: () => import(/* webpackChunkName: "projects" */ '@/views/Projects')
    },
    {
      path: '/zhengxinfu/:id',
      name: 'zhengxinfu',
      component: () => import(/* webpackChunkName: "zhengxinfu" */ '@/views/ZhengXinFu.vue')
    },
    {
      path: '/xinyongtest',
      name: 'xinyongtest',
      component: () => import(/* webpackChunkName: "xinyongtest" */ '@/views/XinyongTest.vue')
    },
    {
      path: '/module',
      name: 'module',
      component: () => import(/* webpackChunkName: "module" */ '@/views/ModuleProducts'),
      meta:{query:{id:0,text:null}}
    },
    {
      path: '/tijian',
      name: 'Tijian',
      component: () => import(/* webpackChunkName: "module" */ '@/views/Tijian')
    },
    
    {
      path: "*",
      name: "error",
      component: () => import("@/views/404.vue")
    }
  ]
})
